import { addDate } from "@/lib/dayjs/add/add-date";
import { addMonth } from "@/lib/dayjs/add/add-month";
import { getFirstDayOfMonth } from "@/lib/dayjs/get-first-day-of-month";
import { getLastDayOfMonth } from "@/lib/dayjs/get-last-day-of-month";
import { getTodaysDate } from "@/lib/dayjs/get-todays-date";

import type { DateRange } from "@/components/ui/calendar/types/calendar-range";

import { PRESET_OPTIONS_MAP } from "../../type";

import type { PresetOptionsType } from "../../type";

export const useComputeTargetDate = () => {
	const computeTargetDateForRange = (value: PresetOptionsType): DateRange => {
		const today = getTodaysDate();

		switch (value) {
			case PRESET_OPTIONS_MAP.TODAY: {
				return { from: today, to: today };
			}
			case PRESET_OPTIONS_MAP.LAST_7_DAYS: {
				const sevenDaysAgo = addDate({ date: today, inc: -7 });
				return { from: sevenDaysAgo, to: today };
			}
			case PRESET_OPTIONS_MAP.NEXT_7_DAYS: {
				const sevenDaysLater = addDate({ date: today, inc: 7 });
				return { from: today, to: sevenDaysLater };
			}
			case PRESET_OPTIONS_MAP.THIS_MONTH: {
				const firstDayOfMonth = getFirstDayOfMonth({ date: today });
				const lastDayOfMonth = getLastDayOfMonth({ date: today });
				return { from: firstDayOfMonth, to: lastDayOfMonth };
			}
			case PRESET_OPTIONS_MAP.LAST_MONTH: {
				const lastMonth = addMonth({ amount: -1, date: today });
				const firstDayOfMonth = getFirstDayOfMonth({ date: lastMonth });
				const lastDayOfMonth = getLastDayOfMonth({ date: lastMonth });
				return { from: firstDayOfMonth, to: lastDayOfMonth };
			}
			case PRESET_OPTIONS_MAP.NEXT_MONTH: {
				const nextMonth = addMonth({ amount: 1, date: today });
				const firstDayOfMonth = getFirstDayOfMonth({ date: nextMonth });
				const lastDayOfMonth = getLastDayOfMonth({ date: nextMonth });
				return { from: firstDayOfMonth, to: lastDayOfMonth };
			}
		}
	};

	return {
		computeTargetDateForRange,
	};
};
